import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { retrieveToken } from '../../../utils/storage';

export const rolesApi = createApi({
    reducerPath: 'rolesPermitted',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL
    }),
    tagTypes: ['roles', 'capability'],
    endpoints: (builder) => ({
        getRoles: builder.query({
            query: () => ({
                url: "/admin/IdentityRole",
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${retrieveToken()}`
                }
            }),
            providesTags: ['roles'],
        }),
        getRoleById: builder.query({
            query: (id) => ({
                url: `/admin/IdentityRole/${id}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${retrieveToken()}`
                }
            }),
            providesTags: ['role'],
        }),
        createRole: builder.mutation({
            query: (newRole) => ({
                url: '/admin/IdentityRole',
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${retrieveToken()}`,
                },
                body: newRole,
            }),
            invalidatesTags: ['roles'],
        }),
        updateRole: builder.mutation({
            query: (role) => ({
                url: `/admin/IdentityRole`,
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${retrieveToken()}`,
                },
                body: role,
            }),
            invalidatesTags: ['roles'],
        }),
        deleteRole: builder.mutation({
            query: (id) => ({
                url: `/admin/IdentityRole/${id}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${retrieveToken()}`,
                }
            }),
            invalidatesTags: ['roles'],
        }),
        getCapability: builder.query({
            query: () => ({
                url: "admin/Capability/getAll",
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${retrieveToken()}`
                }
            }),
            providesTags: ['capability'],
        }),

        getCapabilityId: builder.query({
            query: (id) => ({
                url: `/admin/Capability/getById/${id}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${retrieveToken()}`
                }
            }),
        }),
        getCapabilityRoleId: builder.query({
            query: (roleId) => ({
                url: `/admin/Capability/getByRole/${roleId}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${retrieveToken()}`
                }
            }),
        }),
        assignCapability: builder.query({
            query: ({ id, capabilityId }) => ({
                url: `/admin/IdentityRole/${id}/AssignCapability/${capabilityId}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${retrieveToken()}`
                }
            }),
            invalidatesTags: ['role', 'roles', 'capability'],
        }),
        revokeCapability: builder.query({
            query: ({ id, capabilityId }) => ({
                url: `/admin/IdentityRole/${id}/RevokeCapability/${capabilityId}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${retrieveToken()}`
                }
            }),
            invalidatesTags: ['role', 'roles', 'capability'],
        }),

    }),
});

export const {
    useGetRolesQuery,
    useGetRoleByIdQuery,
    useCreateRoleMutation,
    useUpdateRoleMutation,
    useDeleteRoleMutation,
    useGetCapabilityQuery,
    useGetCapabilityIdQuery,
    useGetCapabilityRoleIdQuery,
    useAssignCapabilityQuery,
    useRevokeCapabilityQuery
} = rolesApi;